import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "next-themes";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { Sun as SunIcon, Moon as MoonIcon, SignOut as SignOutIcon } from "@phosphor-icons/react";

export default function DriverLayout({ children }) {
  const { user, logout } = useAuth();
  const { theme, setTheme } = useTheme();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/login"); };

  return (
    <div className="min-h-screen bg-background">
      <header className="h-16 border-b border-border glass sticky top-0 z-30 flex items-center gap-3 px-4 lg:px-8">
        <Logo size={36} showText />
        <div className="ml-auto flex items-center gap-2">
          <div className="text-right mr-1 hidden sm:block">
            <div className="text-sm font-medium leading-tight">{user?.name}</div>
            <div className="text-[11px] text-muted-foreground">Driver Portal</div>
          </div>
          <div className="h-9 w-9 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-head font-semibold text-sm">
            {(user?.name || "D").slice(0, 1)}
          </div>
          <button onClick={() => setTheme(theme === "dark" ? "light" : "dark")} className="p-2 rounded-md hover:bg-secondary transition-colors" data-testid="theme-toggle">
            {theme === "dark" ? <SunIcon size={20} weight="duotone" /> : <MoonIcon size={20} weight="duotone" />}
          </button>
          <button onClick={doLogout} className="p-2 rounded-md hover:bg-destructive/10 hover:text-destructive transition-colors" data-testid="driver-logout">
            <SignOutIcon size={20} />
          </button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto p-4 lg:p-8">{children}</main>
    </div>
  );
}
